module.exports = __webpack_public_path__ + "assets/images/28539f3a1aae3df7032ab5e8e7cb9f61.png";